module.exports = __webpack_public_path__ + "img/26.0a683f98.jpg";